import { buildProps, definePropType } from '../../../utils/vue/props/runtime.mjs';

const iconProps = buildProps({
  size: {
    type: definePropType([Number, String])
  },
  color: {
    type: String
  }
});

export { iconProps };
//# sourceMappingURL=icon2.mjs.map
